




































































































import {
  ServicePriceComputation,
  ServiceComputationFieldError
} from '@/models';
import { omitDeep, scrollToBottomOfHtmlElement } from '@/utils/helpers';
import { PropType } from 'vue';
import QuoteServiceTemplateComputation from '@/components/quotes/templates/services/QuoteServiceTemplateComputation.vue';

import mixins from '@/utils/mixins';
import Validatable from '@/mixins/validatable';
import BindsAttrs from '@/mixins/binds-attrs';
const baseMixins = mixins(BindsAttrs, Validatable);

export default baseMixins.extend({
  components: { QuoteServiceTemplateComputation },
  name: 'ComputationList',

  props: {
    value: {
      required: false,
      type: Array as PropType<ServicePriceComputation[]>,
      default: () => []
    },

    fieldErrors: {
      required: false,
      type: Array as PropType<ServiceComputationFieldError[]>,
      default: () => []
    },

    disabled: {
      type: Boolean,
      default: false
    },

    multiple: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      internalLazyValue: this.value
    };
  },

  computed: {
    internalValue: {
      get(): unknown {
        return this.internalLazyValue;
      },
      set(val: any) {
        if (val === this.internalLazyValue) return;

        this.internalLazyValue = val;

        // hack for passing multiple function on the emit values
        this.$emit('input', val);
      }
    }
  },

  watch: {
    value(val) {
      this.internalLazyValue = val;
    },

    internalValue: {
      handler() {
        this.validate();
      },
      deep: true
    }
  },

  methods: {
    async addComputation() {
      const computation = new ServicePriceComputation();

      if (!this.multiple) {
        computation.description = 'Calculate the number of days for service';
      }
      this.internalValue.push(computation);
      return await scrollToBottomOfHtmlElement('#scrollable-card');
    },

    copyLastComputation(computations: ServicePriceComputation[]) {
      const lastComputation = computations[computations.length - 1];
      const clonedComputation = omitDeep(lastComputation, ['id']);
      clonedComputation.description = '';
      computations.push(clonedComputation);
    },

    removeComputation(index: number) {
      this.internalValue.splice(index, 1);
    }
  }
});
